import { motion } from 'framer-motion';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_aravell-staging/artifacts/ibb3s625_UGOLF%20ARAVELL%20-%20ANDORRA%20-%20BLANCO.svg";

export const SectionHero = ({ 
  image, 
  title, 
  subtitle
}) => {
  return (
    <section className="section-hero" data-testid="section-hero">
      <div className="absolute inset-0 overflow-hidden">
        <motion.img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-center"
          initial={{ scale: 1.05 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
          loading="eager"
        />
      </div>

      {/* Subtle gradient only at bottom for text readability - no dark overlay */}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/50 to-transparent" />

      {/* Logo institucional - only visible on desktop/tablet */}
      <motion.img
        src={LOGO_URL}
        alt="UGOLF Aravell Andorra"
        className="absolute hidden md:block md:bottom-16 md:right-16 lg:right-20 md:w-[13vw] md:min-w-[140px] md:max-w-[220px] h-auto opacity-90 drop-shadow-lg pointer-events-none"
        style={{ maxHeight: '20%' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.9 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        data-testid="hero-logo"
      />

      <div className="absolute inset-0 flex items-end">
        <div className="container-custom pb-8 md:pb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="max-w-2xl"
          >
            <h1 
              className="font-display text-3xl sm:text-4xl lg:text-6xl text-white font-medium tracking-tight mb-3 md:mb-4 drop-shadow-lg"
              data-testid="section-hero-title"
            >
              {title}
            </h1>
            {subtitle && (
              <p 
                className="text-sm md:text-base lg:text-lg text-white/90 max-w-xl drop-shadow-md"
                data-testid="section-hero-subtitle"
              >
                {subtitle}
              </p>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SectionHero;
